export const mensajesChat = {
  // NewConversationModal.vue — start a new WhatsApp conversation
  newConversation: {
    nameTooShort: "Saisissez le nom sous lequel vous souhaitez être reconnu.",
    saveNameError: "Impossible d'enregistrer le nom de l'entreprise.",
    started: "Conversation démarrée.",
    sent: "Message envoyé.",
    startError: "Impossible de démarrer la conversation.",
    titleConnect: "Connectez votre WhatsApp",
    titleName: "Le nom de votre entreprise",
    titleNew: "Nouvelle conversation",
    subtitleConnect: "Nécessaire pour pouvoir écrire en premier",
    subtitleName: "C'est le nom sous lequel les gens verront le message arriver",
    subtitleNew: "Écrivez à n'importe quel numéro sur WhatsApp",
    close: "Fermer",
    senderStripPre: "Sera envoyé en tant que",
    change: "Modifier",
    connectBody:
      "Pour écrire en premier, le message doit provenir de <strong>votre propre numéro WhatsApp Business</strong>. Avec le numéro partagé de WACheckin, les gens verraient un téléphone qui n'est pas le vôtre, et nous ne pourrions pas vous présenter sous le nom de votre entreprise.",
    connectItem1: "Écrivez à n'importe quel numéro, avec ou sans réservation",
    connectItem2: "Le nom de votre entreprise apparaît comme expéditeur",
    connectItem3: "Les réponses arrivent dans cette même boîte de réception",
    connectFoot: "Connectez-vous une seule fois, depuis Intégrations → WhatsApp.",
    previewLabel: "Comment ils le verront",
    previewGreeting: "Bonjour 👋",
    previewFromPre: "Nous vous écrivons de la part de",
    previewFromPost: ".",
    previewCtaPre: "Nous avons un message pour vous. Répondez",
    previewOk: "Ok",
    previewCtaPost: "et nous vous l'enverrons.",
    fallbackBusiness: "votre entreprise",
    nameLabel: "Nom de l'entreprise",
    namePlaceholder: "Gîte du Soleil Levant",
    nameHelp:
      "Il est enregistré sous Agent IA → Nouvelles réservations, et vous pouvez le modifier là-bas ou ici quand vous le souhaitez.",
    recipientLabel: "Destinataire",
    messageLabel: "Message",
    messagePlaceholder: "Rédigez votre message…",
    cancelSoft: "Pas maintenant",
    cancel: "Annuler",
    connectBtn: "Connecter WhatsApp",
    continueBtn: "Continuer",
    sendBtn: "Envoyer le message",
  },

  // MessageTranslate.vue — per-message translation in chat bubbles
  translate: {
    // BarraTraduccion.vue — la barre du traducteur du chat (automatique + aperçu)
    off: "Traduction automatique désactivée",
    on: "Traduction active",
    turnOn: "Traduire ce qui arrive et voir avant ce que vous écrivez",
    turnOff: "Désactiver la traduction automatique",
    guestWrites: "le voyageur écrit en {idioma}",
    nothingToDo: "Rien à traduire : le voyageur écrit en {idioma}",
    youRead: "Vous le lisez en",
    willBeSentIn: "ce que vous écrivez partira en",
    pickOutgoing: "Dans quelle langue il le recevra",
    theirs: "la sienne",
    willArriveAs: "Il le recevra ainsi, en {idioma} :",
    sendIn: "Envoyer en {idioma}",
    cancel: "Annuler",
    discard: "Abandonner",
    enterSends: "Entrée pour envoyer",
    translating: "Traduction en cours…",
    translate: "Traduire",
    viewTranslation: "Voir la traduction",
    viewOriginal: "Voir l'original",
    translated: "Traduit",
    copy: "Copier",
    copied: "Copié",
    error: "Impossible de traduire. Veuillez réessayer.",
  },

  // Phone.vue — WhatsApp-style chatbot preview
  phone: {
    online: "En ligne",
    today: "Aujourd'hui",
    sampleQuestion: "À quelle heure est le check-in ?",
    answerPlaceholder: "Rédigez votre réponse ici...",
    inputPlaceholder: "Saisissez un message...",
  },

  // selectorTypeIframe.vue — subscription billing period selector
  billing: {
    selectPeriod: "Choisissez une période",
    selectPeriodHint: "Choisissez comment vous souhaitez payer",
    monthly: "Mensuel",
    annual: "Annuel",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "À qui vous écrivez",
    modeOne: "Message simple",
    modeGroup: "Message groupé",
    allOtas: "Toutes",
    needsWhatsapp: "Connectez votre WhatsApp pour utiliser ce canal",
    connectNow: "Le connecter",
    varsLabel: "Variable",
    vars: {
      nombre: "Le nom du client",
      alojamiento: "Le nom du logement",
      entrada: "La date d'arrivée",
      salida: "La date de départ",
      codigo: "Le code de la réservation",
    },
    remove: "Retirer",
    oneEach: "Chaque client le reçoit une seule fois, par le premier canal disponible.",
    noContact: "1 sans moyen de contact | {count} sans moyen de contact",
    otaLabel: "Quelle OTA",
    emoji: "Émoji",
    attach: "Joindre un fichier",
    noFileOta: "Le fichier ne passe pas par l'OTA",
    previewLabel: "Rendu du message",
    fileTooBig: "« {name} » pèse {size} Mo et la limite WhatsApp pour ce type est de {max} Mo",
    fileNotAllowed: "Seuls les images (JPG, PNG, GIF), les PDF et la vidéo MP4 sont acceptés : WhatsApp ne lit pas les autres formats.",
    attachHint: "Images et PDF jusqu'à 10 Mo · vidéo MP4 jusqu'à 15 Mo",
    channelLabel: "Par quel canal",
    channels: { whatsapp: "WhatsApp", email: "E-mail", ota: "OTA" },
    groupLabel: "Quels clients",
    groups: {
      alojados: "Sur place",
      entran_hoy: "Arrivent aujourd'hui",
      entran: "Arrivent bientôt",
      salen: "Partent aujourd'hui",
    },
    withinPre: "dans les",
    withinPost: "jour | jours",
    empty: "Aucun client dans ce groupe pour le moment.",
    reachOf: "sur {total} le recevra | sur {total} le recevront",
    queuedSilently: "1 ne reçoit aucun avis aujourd'hui : il en avait déjà un en attente | {count} ne reçoivent aucun avis aujourd'hui : ils en avaient déjà un en attente",
    noChannel: {
      whatsapp: "1 sans téléphone | {count} sans téléphone",
      email: "1 sans e-mail | {count} sans e-mail",
      ota: "1 sans fil OTA | {count} sans fil OTA",
    },
    billed: "1 conversation WhatsApp est facturée | {count} conversations WhatsApp sont facturées",
    showList: "Voir le destinataire | Voir les {count} destinataires",
    hideList: "Masquer la liste",
    noName: "Sans nom",
    states: {
      directo: "reçu",
      plantilla: "invitation",
      en_cola: "en avait déjà un",
      sin_telefono: "sans téléphone",
      sin_correo: "sans e-mail",
      sin_hilo_ota: "sans fil",
      sin_contacto: "sans contact",
    },
    sending: "Envoi à 1 client | Envoi à {count} clients",
    sendGroup: "Envoyer à 1 client | Envoyer à {count} clients",
    historial: {
      providerId: "Identifiant du fournisseur. Il sert à retrouver le message dans la console SES.",
      sentMeans: "« Envoyé » veut dire que le fournisseur l'a accepté. Que le client le lise, ou qu'il finisse en indésirables, ne dépend plus de nous.",
      estados: {
        enviando: "En cours d'envoi",
        enviado: "Envoyé",
        en_cola: "En file",
        fallo: "Échec",
        sin_contacto: "Aucun contact",
      },
      title: "Envois groupés",
      subtitle: "Ce qui a été envoyé, à qui, et ce qui s'est passé pour chacun",
      empty: "Vous n'avez encore envoyé aucun message groupé.",
      error: "L'historique n'a pas pu être chargé.",
      sentBy: "par {quien}",
      running: "En cours",
      back: "Retour",
      messageLabel: "Le message",
      recipientsLabel: "Destinataires",
      colName: "Client",
      colVia: "Canal",
      colDest: "Envoyé à",
      colState: "Résultat",
      openChat: "Ouvrir",
      attachment: "Pièce jointe : {nombre}",
      close: "Fermer",
      reached: "{enviados} sur {total}",
      noOne: "Sans nom",
    },
  },
};
